import config from './multilingualInformationalPages.json';

export const LOCALIZED_INFORMATIONAL_PAGES = Array.isArray(config.pages) ? config.pages : [];

export const LOCALIZED_INFORMATIONAL_ROUTE_DEFINITIONS = LOCALIZED_INFORMATIONAL_PAGES.map((page) => ({
  key: page.key,
  nonDefaultLanguageCodes: Array.isArray(page.languages)
    ? page.languages.filter((entry) => entry.code !== 'en').map((entry) => entry.code)
    : [],
}));

export const getLocalizedInformationalDefinition = (pageKey) =>
  LOCALIZED_INFORMATIONAL_PAGES.find((page) => page.key === pageKey);

export const getLocalizedInformationalLanguageEntry = (pageKey, code) => {
  const page = getLocalizedInformationalDefinition(pageKey);
  if (!page || !Array.isArray(page.languages)) {
    return null;
  }
  return page.languages.find((entry) => entry.code === code) || null;
};

export const getLocalizedInformationalCanonicalPath = (pageKey) => {
  const page = getLocalizedInformationalDefinition(pageKey);
  if (!page) {
    return '/';
  }

  return (
    page.xDefaultPath ||
    page.languages?.find((entry) => entry.code === 'en')?.path ||
    page.languages?.[0]?.path ||
    '/'
  );
};

export const buildLocalizedInformationalAlternates = (pageKey) => {
  const page = getLocalizedInformationalDefinition(pageKey);
  if (!page || !Array.isArray(page.languages)) {
    return [];
  }

  const canonicalPath = getLocalizedInformationalCanonicalPath(pageKey);
  return [
    {
      hrefLang: 'en',
      path: canonicalPath,
    },
    {
      hrefLang: 'x-default',
      path: canonicalPath,
    },
  ];
};
